import { useEffect, useRef } from "react";

const InstagramEmbed = ({ url, scale = 0.7 }) => {
  useEffect(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
      return;
    }
    const script = document.createElement("script");
    script.src = "//www.instagram.com/embed.js";
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => window.instgrm?.Embeds.process();
    return () => script.remove();
  }, [url]);

  return (
    <div
      // style={{
      //   width: 326 * scale,
      //   height: 550 * scale, // approximate; adjust based on actual rendered height
      //   overflow: "hidden",
      //   position: "relative",
      // }}
    >
      <div
        // style={{
        //   transform: `scale(${scale})`,
        //   transformOrigin: "top left",
        //   width: 326,
        // }}
      >
        <blockquote
          className="instagram-media"
          data-instgrm-permalink={url}
          data-instgrm-version="14"
          // style={{ margin: "0 auto", maxWidth: 326, minWidth: 326 }}
        />
      </div>
    </div>
  );
};

export default InstagramEmbed;